import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { find } from 'lodash-es';

const DEALER_DISCLAIMER = {
  amsi: 'By providing my number and submitting this form, I agree to receive marketing text messages and phone calls from this dealer at my phone number (including by autodialer or an artificial or prerecorded voice). This consent is not required as a condition of purchase.',
  carmax:
    'By providing my number and submitting this form, I agree to receiving marketing text messages and phone calls from this dealer at my phone number (including by autodialer). This consent is not required as a condition of purchase.',
};

/**
 * Renders additional privacy note for a dealer.
 * @returns {ReactElement}
 */
export function TcpaDisclaimer({ classNames = '', tcpaParentDealershipName = null }) {
  const disclaimer = find(DEALER_DISCLAIMER, (disc, dealer) => tcpaParentDealershipName.toLowerCase().includes(dealer));
  return (
    <div className={classnames('small d-flex align-items-center mb-1', classNames)}>
      <span className="text-gray-darker">{disclaimer}</span>
    </div>
  );
}
TcpaDisclaimer.propTypes = {
  classNames: PropTypes.string,
  tcpaParentDealershipName: PropTypes.string.isRequired,
};
